export default __webpack_public_path__ + "static/media/boosty.9f0fde7d.svg";